import { useState } from "react";
import { Field } from "@/components/common";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

/**
 * Renders the follow-up questions attached to a chosen option
 * (e.g. Virtual Lunch & Learn -> "Which restaurant?").
 */
export function TypeQuestions({ option, answers, onChange, testPrefix = "tq" }) {
  const fields = option?.fields || [];
  if (!fields.length) return null;
  const set = (k, v) => onChange({ ...(answers || {}), [k]: v });
  return (
    <div className="border-l-2 border-cc-blue/30 pl-3 space-y-3" data-testid={`${testPrefix}-questions`}>
      {fields.map((f) => (
        <Field key={f.key} label={`${f.label}${f.required ? " *" : ""}`}>
          {f.type === "select" ? (
            <Select value={(answers || {})[f.key] || ""} onValueChange={(v) => set(f.key, v)}>
              <SelectTrigger data-testid={`${testPrefix}-${f.key}`}><SelectValue placeholder="Choose one" /></SelectTrigger>
              <SelectContent>{(f.options || []).map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}</SelectContent>
            </Select>
          ) : f.type === "textarea" ? (
            <Textarea rows={2} value={(answers || {})[f.key] || ""} onChange={(e) => set(f.key, e.target.value)} data-testid={`${testPrefix}-${f.key}`} />
          ) : (
            <Input type={f.type === "date" ? "date" : f.type === "number" ? "number" : "text"}
              value={(answers || {})[f.key] || ""} onChange={(e) => set(f.key, e.target.value)} data-testid={`${testPrefix}-${f.key}`} />
          )}
        </Field>
      ))}
    </div>
  );
}

/** Validate required follow-up answers; returns the first missing question label. */
export function missingAnswer(option, answers) {
  const f = (option?.fields || []).find((x) => x.required && !((answers || {})[x.key] || "").toString().trim());
  return f?.label || null;
}

export function useTypeAnswers(initial = {}) {
  return useState(initial);
}
